import { del, get, post, put } from '@/shared/api/api-client';
import { injectable } from 'inversify';
import { IBuyerOffer, IBuyerOfferFromApi } from '../ts';

@injectable()
export class BuyerAccountOffersService {
  async getAllOffers() {
    const res = await get(`${PUBLIC_API_URL}/wheat`);
    return res;
  }
  async getOfferData(id: number) {
    const res = await get(`${PUBLIC_API_URL}/wheat/${id}`);
    return res;
  }

  async createNewOffer(dto: IBuyerOffer) {
    const res = await post(`${PUBLIC_API_URL}/wheat`, { ...dto });
    return res;
  }
  async updateOfferData(dto: IBuyerOfferFromApi) {
    const res = await put(`${PUBLIC_API_URL}/wheat/${dto.id}`, { ...dto });
    return res;
  }

  async deleteOffer(id: number) {
    const res = await del(`${PUBLIC_API_URL}/wheat/${id}`);
    return res;
  }
}
